import { Readable } from 'stream'

export type StatusFunction = (status: string) => void
export class IIndexManager {
	checkIndexes!: () => Promise<Response>
	clearIndexes!: (master: boolean, mdx: boolean, files: boolean) => void
}
